<template>
    <el-table-column
    :label="column.hander.label"
    :key="column.prop"
    >
        <template v-for="(col,index) in column.hander.columns">
            <template v-if="col.hander">
                <VelDeepColumn :column="col" :key="col+index" />
            </template>

            <template v-else>
                <el-table-column 
                :prop="col.prop" 
                :label="col.label" 
                :width="col.width" 
                :align="col.align"
                :sortable="col.sortable"
                :key="col+index"
                >
                    <template slot-scope="{row}">
                        <div style="display:inline-block">
                            <!-- 是否开启列表插槽 -->
                            <template v-if="col.slot">
                                <slot :name="col.prop" :row="row"></slot>
                            </template>
                            <!-- 是否开启提示和编译 -->
                            <VelTips
                            v-else-if="column.isTips&&column.isCompile" 
                            :effect="column.isTips.effect?column.isTips.effect:'light'" 
                            :content="column.isCompile(row[column.prop])" placement="top">
                                <span>
                                    {{column.isCompile(row[column.prop]).length>
                                    (column.isTips.max?column.isTips.max:20)?
                                    column.isCompile(row[column.prop]).slice(0,(column.isTips.slice?column.isTips.slice:10))+'...':
                                    column.isCompile(row[column.prop])
                                    }}
                                </span>
                            </VelTips>
                            <!-- 是否开启编译 -->
                            <span v-else-if="col.isCompile">{{col.isCompile(row[col.prop])}}</span>
                            <!-- 是否开启提示 -->
                            <VelTips
                            v-else-if="col.isTips" 
                            :effect="col.isTips.effect?col.isTips.effect:'light'" 
                            :content="row[col.prop]" placement="top">
                                <span >
                                    {{row[col.prop]&&row[col.prop].length>(col.isTips.max?col.isTips.max:20)?
                                    row[col.prop].slice(0,(col.isTips.slice?col.isTips.slice:10))+'...':
                                    row[col.prop]}}
                                </span>
                            </VelTips>
                            <!-- 普通列表 -->
                            <span v-else>{{row[col.prop]}}</span>
                        </div>
                    </template>
                </el-table-column>
            </template>

        </template>
    </el-table-column>
</template>
<script>
import VelTips from '../tips'
export default {
    name:"VelDeepColumn",
    components:{
        VelTips,
    },
    props:{
        column:{
            type:Object,
            required:true,
        }
    }
}
</script>